import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";

interface RevokeTaxSubmissionRequest {
    taxSubmissionId: string;
    taxPayerDocuments: {
        protocol: string;
        taxId: string;
    }[];
}

export const useRevokeTaxSubmissions = () => {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders({ method: "POST" });
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (request: RevokeTaxSubmissionRequest) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${request.taxSubmissionId}/revoke`,
                {
                    headers,
                    method: "POST",
                    body: JSON.stringify({
                        taxPayerDocuments: request.taxPayerDocuments,
                    }),
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissions"],
            });
            queryClient.invalidateQueries({ queryKey: ["useGetKPIs"] });
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissionDetail"],
            });
        },
        meta: {
            errorMessage: t("errors.messages.revokeTaxSubmissions"),
        },
    });

    return mutation;
};
